var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"user-fans-counter"},[_vm._v(" "+_vm._s(_vm.text)+": "+_vm._s(_vm.value)+" "),_c('span',{staticClass:"see-button"},[_vm._v(" "+_vm._s(_vm.$t('users.see'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }